import { Link } from "react-router-dom";
import { useStore } from "../context/StoreContext";
import { useLang } from "../context/LanguageContext";
import { useSiteContent } from "../hooks/useSiteContent";

export default function Footer() {
  const { settings } = useStore();
  const { t } = useLang();
  const { img, raw } = useSiteContent();
  const logo = img("logo_url", "");
  const locations = raw("footer_locations", "Santiago · Lima · Perth").split(/\n|,/).map((s) => s.trim()).filter(Boolean);
  return (
    <footer data-testid="footer" className="relative bg-inverse text-[color:var(--bg)] overflow-hidden grain">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 pt-24 pb-10">
        <div className="grid md:grid-cols-[1.5fr_1fr_1fr] gap-12 mb-20">
          <div>
            <div className="flex items-center gap-2 mb-6">
              {logo ? <img src={logo} alt={settings.brand_name} className="h-8 w-auto object-contain" /> : (
                <><span className="w-3 h-3 bg-gold rotate-45" /><span className="font-display font-extrabold text-2xl">{settings.brand_name}</span></>
              )}
            </div>
            <p className="text-[color:var(--bg)]/60 max-w-sm leading-relaxed">{t("footer.tagline")}</p>
          </div>
          <div>
            <p className="overline text-gold mb-5">{t("footer.solutions")}</p>
            <ul className="space-y-3 text-[color:var(--bg)]/70">
              <li><Link to="/equipos" className="hover:text-gold transition-colors">{t("nav.equipos")}</Link></li>
              <li><Link to="/software" className="hover:text-gold transition-colors">{t("nav.software")}</Link></li>
              <li><Link to="/consultoria" className="hover:text-gold transition-colors">{t("nav.consultoria")}</Link></li>
            </ul>
          </div>
          <div>
            <p className="overline text-gold mb-5">{t("footer.contact")}</p>
            <ul className="space-y-3 text-[color:var(--bg)]/70">
              <li>{raw("footer_email", "ventas@oomining.com")}</li>
              <li>{raw("footer_phone", "+56 2 2345 6789")}</li>
              {locations.map((l, i) => <li key={i}>{l}</li>)}
            </ul>
          </div>
        </div>

        <div className="border-t border-[color:var(--bg)]/15 pt-8 flex flex-col md:flex-row justify-between gap-4 text-sm text-[color:var(--bg)]/50">
          <span>© {new Date().getFullYear()} {settings.brand_name} {t("footer.rights")}</span>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-gold transition-colors font-mono">{t("footer.admin")}</Link>
        </div>
      </div>

      <div className="select-none pointer-events-none">
        <h2 className="font-display font-extrabold leading-none text-[18vw] tracking-tighter text-[color:var(--bg)]/[0.04] px-4 -mb-[3vw]">
          {settings.brand_name.toUpperCase()}
        </h2>
      </div>
    </footer>
  );
}
